(function () {
    // locate the shared leica "namespace" object so we can pass it to the conferencing service
    var leica = namespace.using('leica');
    var util = namespace.create('leica.pi.util');

    // initialize the conferencing listener service
    window.apConferencing.init($, new util.EventChannel(), window.SystemParms, window.translate, leica);

    // Expose "confEvents" for the viewer, but really this has no business being here.
    window.confEvent = window.apConferencing.confEvent;

    // Open the viewer when asked to by conferencing.
    util.conference.events.on('lbs-dsc-launch-webviewer-now', function (dscId, dscInvitationId, acceptMessage) {
        var windowName = window.SystemParms.WebViewerTargetFrameName || 'WebViewer';
        var url = '/app/' + window.SystemParms.whichWebViewer + '/conference/join/' + dscId + '/' + dscInvitationId;
        if (acceptMessage) {
            url += '?message=' + encodeURIComponent(acceptMessage);
        }
        window.open(url, windowName);
    });
}());
